import _typeof from "@babel/runtime/helpers/typeof";

/**
 * Copyright IBM Corp. 2022, 2022
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
// Utility to return a deep clone of a nested object or array.
export var deepCloneObject = function deepCloneObject(objectToClone) {
  // Return the value if objectToClone is not an object
  if (_typeof(objectToClone) !== 'object' || objectToClone === null) {
    return objectToClone;
  } // Create a new array/object to hold the values


  var clonedObject = Array.isArray(objectToClone) ? [] : {};

  for (var key in objectToClone) {
    var value = objectToClone[key]; // Recursively check for nested objects/arrays

    clonedObject[key] = deepCloneObject(value);
  }

  return clonedObject;
};